import zentakeApi from '../../api/index'
import { isFilledArray } from '../helpers'

async function setFormResponsesAsSubmitted(
  updatedPacketResponse,
  mode,
  mannuallySubmitted: boolean = undefined
) {
  if (!isFilledArray(updatedPacketResponse?.responses)) return

  return await Promise.all(
    updatedPacketResponse.responses.map((formResponse) =>
      zentakeApi.submitResponse(formResponse.id, mode, mannuallySubmitted)
    )
  )
}

export default setFormResponsesAsSubmitted
